var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookVerificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.165,
    height: 8.165,
    viewBox: "0 0 8.165 8.165",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.083,0A4.083,4.083,0,1,0,8.165,4.083,4.083,4.083,0,0,0,4.083,0ZM3.45,5.967,1.571,4.088l.722-.722L3.45,4.523,5.9,2.069l.722.722Z",
    fill: "#1976d2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookVerificationIcon);
export default __webpack_public_path__ + "static/media/facebook-verification-icon.2104361f36ba927227c76416b796a891.svg";
export { ForwardRef as ReactComponent };